import { Button } from "@/components/ui/button"
import { Link } from "@tanstack/react-router"

export default function CatchAll() {
  return (
    <>
      <div className="flex flex-col items-center">
        <p className="text-base font-semibold text-indigo-400">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight  sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-300">
          Sorry, we couldn’t find the page you’re looking for.
        </p>
        <div className="mt-10">
          <Button asChild>
            <Link to={"/"}>Go back home</Link>
          </Button>
        </div>
      </div>
    </>
  )
}
